export const EmpresaUsuarioGrupo = {
    nombre: {
        header: 'Grupos',
        table: true,
        sort: true,
        filter: true,
        filterPlaceholder: 'Filtrar por grupo'
    },
    corporacion: {
        header: 'Corporación',
        table: true,
        sort: true,
        filter: false
    },
    fecha: {
        header: 'Fecha de asignación',
        table: true,
        sort: true
    }
};